import  "./Article.css";

const Article = function (props) {
    return (
        <div className="card">
            {/* <div className="cardddd"> */}
                <div className="card-body row no-gutters"> 
                    <div className="col-4 pageIcon">
                        <img clas="" src={ props.data.MOLinkDetailImage.ImageUrl} data-holder-rendered="true" />
                    </div>
                    <div className="col-8 card-text">
                        <h3 >{props.data.Title}</h3>
                        <div className="articleSubTitle" dangerouslySetInnerHTML={{__html: props.data.ModLinkSubTitle}}></div>
                    </div>
                </div>
            {/* </div> */}
            <div className="card-link">
                <a href={props.data.ModLinkDetailsLink.NavigateUrl} title={props.data.ModLinkDetailsLink.ToolTip}>
                            <div className="link-text">קרא עוד</div>
                            <div className="traingle-bottom orange-traingle"></div>
                </a>
            </div>
        </div>
    );
}
    export default Article;